import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalDialogConfiguration } from '@supoui/shared/model/modal/modal-dialog-configuration';

@Component({
    selector: 'app-confirm-modal',
    templateUrl: './confirm-modal.component.html',
    styleUrls: ['./confirm-modal.component.scss'],
    standalone: false
})
export class ConfirmModalComponent implements OnInit {
  configuration: ModalDialogConfiguration;

  constructor(public activeModal: NgbActiveModal) {}

  ngOnInit(): void {}

  init(configuration: ModalDialogConfiguration): void {
    this.configuration = configuration;
  }
}
